import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { WarehouseMovementEntity } from '../../entities/warehouseMovement.entity';
import { getLatestUpdatedAt } from '../../helper/reducer.helper';
import { WarehouseMovementActionTypes } from '../actions/warehouse-movement.actions';

export const WAREHOUSE_MOVEMENT__KEY = 'WarehouseMovement';

export interface WarehouseMovementState extends EntityState<WarehouseMovementEntity> {
    fetched: boolean;
    latestUpdatedAt: Date;
}

const adapter = createEntityAdapter<WarehouseMovementEntity>({
    selectId: (Entity) => Entity.Id,
});

const initialState = adapter.getInitialState({
    fetched: false,
    latestUpdatedAt: null,
});

export const warehouseMovementReducer = createReducer(
    initialState,
    on(WarehouseMovementActionTypes.UpdateAll, (state, { Payload, updateLatestUpdatedAt }) =>
        adapter.setAll(Payload, { ...state, fetched: true, latestUpdatedAt: updateLatestUpdatedAt ? getLatestUpdatedAt(Payload, state.latestUpdatedAt) : state.latestUpdatedAt }),
    ),
    on(WarehouseMovementActionTypes.UpdateMany, (state, { Payload, updateLatestUpdatedAt }) =>
        adapter.setMany(Payload, { ...state, fetched: true, latestUpdatedAt: updateLatestUpdatedAt ? getLatestUpdatedAt(Payload, state.latestUpdatedAt) : state.latestUpdatedAt }),
    ),
    on(WarehouseMovementActionTypes.CreateSuccess, (state, { Payload }) => adapter.setOne(Payload, { ...state })),
);

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectAllWarehouseMovement = selectAll;
export const selectWarehouseMovementEntities = selectEntities;

export const selectWarehouseMovementFetched = (state: WarehouseMovementState) => state.fetched;
export const selectWarehouseMovementLatestUpdatedAt = (state: WarehouseMovementState) => state.latestUpdatedAt;
